import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSofa: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="sofa, couch, chill"><path d="M1.75 10.75H5.75V13.3214H18.25V10.75H22.25V17.25H1.75V10.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M20.25 10.25V4.75H3.75V10.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M5.75 17.25V19.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M18.25 17.25V19.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconSofa;
